import React from 'react'
import { subscribe } from 'react-contextual'
import { Helmet } from 'react-helmet'
import CommunicationsProvider from '../CommunicationsProvider'
import { ListingTemplate, TableProvider } from '../../../views/components'
import { EmailLogSearchFilter, EmailLogTable } from '..'
import { useEffectOnce } from 'react-use'
import { lastDayOfMonth, format } from 'date-fns'

interface CommunicationsPageProps {
  match?: object
  userRole?: string
  isLoading?: boolean
  fetchEmails: (startDate: string, endDate: string) => void
}

const CommunicationsPage = ({ isLoading, fetchEmails }: CommunicationsPageProps) => {
  const filterStartDate = new Date().setDate(1)
  const filterEndDate = lastDayOfMonth(new Date())

  useEffectOnce(() => {
    fetchEmails(format(filterStartDate, 'yyyy-MM-dd'), format(filterEndDate, 'yyyy-MM-dd'))
  })

  return (
    <>
      <Helmet>
        <title>reOS | Communications</title>
      </Helmet>
      <TableProvider>
        <ListingTemplate loading={isLoading} Header={<EmailLogSearchFilter />} Body={<EmailLogTable />} />
      </TableProvider>
    </>
  )
}

export default subscribe(
  [CommunicationsProvider],
  ({ isLoading, fetchEmails }: Pick<CommunicationsPageProps, 'isLoading' | 'fetchEmails'>) => ({
    isLoading,
    fetchEmails,
  }),
)(CommunicationsPage)
